export default "https://statics.cloudfastin.top/static/v1.27.31/store/images/aliexpress2.png?8c8009cbe251b0b72cc86a9c5823257e";